import { CoreInterfaces } from "./../Models";
import * as Constants from "../Constants/Constants";
import { servicesReducer } from "./reducers/servicesReducer";
import { configurationReducer } from "./reducers/configurationReducer";
import { uiReducer } from "./reducers/uiReducer";
import { contactsReducer } from "./reducers/contactsReducer";
import { identityReducer } from "./reducers/identityReducer";
import { orchestrationReducer } from "./reducers/orchestrationReducer";

/**
 * Root reducer that composes slice reducers.
 *
 * Clean slices run first — each returns Partial<AppState> for its
 * actions or {} if the action is not handled by that slice. Results
 * are spread over the current state to produce a composed snapshot.
 *
 * The orchestration reducer runs last on the composed state.
 * It handles the 7 cross-cutting actions that touch multiple slices.
 * For non-orchestration actions it returns state unchanged.
 */
export function appReducer(
  state: CoreInterfaces.AppState,
  action: { type: Constants.AppStateActions; payload?: any }
): CoreInterfaces.AppState {
  // Clean slices — each returns Partial<AppState> or {} if not handled.
  // Only one slice will match any given action, so spreading is safe.
  const sliced: CoreInterfaces.AppState = {
    ...state,
    ...servicesReducer(state, action),
    ...configurationReducer(state, action),
    ...uiReducer(state, action),
    ...contactsReducer(state, action),
    ...identityReducer(state, action),
  };

  // Orchestration runs last on the already-sliced state.
  return orchestrationReducer(sliced, action);
}
